// DonaQRCodeScanner.jsx
import React from 'react';
import Html5QrcodePlugin from './Html5QrcodePlugin';
import MainLayout from '../../layouts/MainLayout';
import './QRPlugin.css';

const DonaQRCodeScanner = () => {
    const onNewScanResult = (decodedText, decodedResult) => {
        // Handle decoded results here
        // console.log('New scan result:', decodedText);
    };

  return (
    <MainLayout>
        <h3 className='text-lg mt-1 mx-8 border-b border-b-gray-300 text-white'>Think5Whys DonaScan</h3>
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '4rem', width: '60%' }}>
            <Html5QrcodePlugin
                fps={20}
                qrbox={300}
                disableFlip={false}
                qrCodeSuccessCallback={onNewScanResult}
            />
        </div>
    </MainLayout>
  );
};

export default DonaQRCodeScanner;



